export const display_infrastructure_field = ["padang"];
